import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/mobile/HomeM.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/aboutM',
    name: 'aboutM',
    component: () => import(/* webpackChunkName: "about" */ '../views/mobile/AboutM.vue')
  },
  {
    path: '/technologyM',
    name: 'technologyM',
    component: () => import(/* webpackChunkName: "technology" */ '../views/mobile/technologyM.vue')
  },
  {
    path: '/contactUsM',
    name: 'contactUsM',
    component: () => import(/* webpackChunkName: "contactUs" */ '../views/mobile/contactUsM.vue')
  },
  {
    path: '/publicM',
    name: 'publicM',
    component: () => import(/* webpackChunkName: "public" */ '../views/mobile/publicM.vue')
  },
  {
    path: '/redBookM',
    name: 'redBookM',
    component: () => import(/* webpackChunkName: "redBook" */ '../views/mobile/redBookM.vue')
  },
  {
    path: '/mediumM',
    name: 'mediumM',
    component: () => import(/* webpackChunkName: "medium" */ '../views/mobile/mediumM.vue')
  }
]

// const router = createRouter({
//   history: createWebHashHistory(),
//   routes
// })

export default routes
